module.exports = __webpack_public_path__ + "components/country-flag/static/kh-e712826ef0b39cd45ab3b34e57558e56.svg";